import { ModuleWithProviders, NgModule } from '@angular/core';
import { XMEDICAL_CONFIG, XMedicalConfig, API_BASE_URL, ADMIN_API_BASE_URL } from './config';
import { StorageModule } from './storage';

/**
 * XMedical Core Module
 * Provides core services, repositories, and API access
 *
 * @example
 * ```typescript
 * import { XMedicalCoreModule } from '@xmedical/core';
 *
 * @NgModule({
 *   imports: [
 *     XMedicalCoreModule.forRoot({
 *       apiUrl: environment.api,
 *       adminApiUrl: environment.adminApi,
 *       version: environment.version
 *     })
 *   ]
 * })
 * export class AppModule {}
 * ```
 */
@NgModule({
  imports: [
    StorageModule
  ]
})
export class XMedicalCoreModule {
  /**
   * Configure the XMedical Core library with application-specific settings
   *
   * @param config - Configuration object containing API URLs, auth settings, etc.
   * @returns Module with providers
   */
  static forRoot(config: XMedicalConfig): ModuleWithProviders<XMedicalCoreModule> {
    return {
      ngModule: XMedicalCoreModule,
      providers: [
        // Provide the main configuration
        {
          provide: XMEDICAL_CONFIG,
          useValue: config
        },
        // Provide convenience tokens for API URLs
        {
          provide: API_BASE_URL,
          useValue: config.apiUrl
        },
        {
          provide: ADMIN_API_BASE_URL,
          useValue: config.adminApiUrl
        }
      ]
    };
  }
}
